module.exports = __webpack_public_path__ + "img/icon-tools.2b0e817c.svg";